import { render } from "./BatchRemovalConfirmationDialog.vue?vue&type=template&id=5149cc1c"
import script from "./BatchRemovalConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BatchRemovalConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__